// context to hold the meta details for payment link
import React from 'react';

export const metaContext = React.createContext();

const MetaProvider = props => {
  const { Provider } = metaContext;
  const [isLoading, setIsLoading] = React.useState(false);

  const [metaValues, setMetaValues] = React.useState({});
  const [extraValues, setExtraValues] = React.useState({});

  const values = React.useMemo(() => {
    return {
      metaValues,
      setMetaValues,
      extraValues,
      setExtraValues
    };
  }, [metaValues, extraValues]);
  return <Provider value={{ ...values, isLoading, setIsLoading }} {...props} />;
};

export default MetaProvider;

// custom hook for accessing meta data
export const useMeta = () => {
  const context = React.useContext(metaContext);

  if (!context) {
    throw new Error('useMeta must be used within a MetaProvider');
  }

  return context;
};
